import styled from "styled-components";
import petri_img from '../../image/szalka.svg'

export const ContentContainer = styled.div`
    display: flex;
    margin-top: 15px;
`

export const Input = styled.input`
    padding: 10px;
    font-size: 16px;
    border: 2px solid #ccc;
    border-radius: 5px;
    outline: none;
    transition: border-color 0.3s;
    max-width: 100px;
    &:focus {
        border-color: #007bff;
    }
`;

export const Label = styled.label`
    text-align: right;
    font-weight: bold;
    padding-right: 10px;
    max-width: 300px;
    width: 100%;
`

export const RowForm = styled.div`
    display: flex;
    padding-top: 10px;
`

export const InputContainer = styled.div`
    display: block;
    align-items: center;
    max-width: 400px; 
`

export const ChartContainer = styled.div`
    position: relative;
    width: 100%;
    margin: auto;
    max-width: 1200px;
`

export const Animation = styled.div`
    margin-left: auto;
    margin-right: auto;
    align-items: center;
    position: absolute;
    left: 50%;
    align-content: center;
    
`

export const Bacteries = styled.img`
    position: absolute;
    width: 3%;
    height: auto;
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 0.5s ease, transform 0.5s ease;
    top: ${props => props.top}%;
    left: ${props => props.left}%;
    
    &.visible {
        opacity: 1;
        transform: scale(1);
    }
`

export const Petri = styled.img`
    width: 400px;
    height: 400px;
    align-self: center;
    //margin-left: 10%;
`

export const AnimationButton = styled.button`
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: none;
    background-color: #333;
    color: white;
    transition: 0.3s;
    margin-bottom: 20px;

    &:hover {
        background-color: #565555;
    }
`

export const BakteriaContainer = styled.div`
    position: relative;
    width: 400px;
    height: 400px;
    overflow: hidden;
    background-image: url(${petri_img});
    background-size: 110% 110%;
    background-position: center;
    background-repeat: no-repeat;
    background-clip: border-box;
    border-radius: 50%;
    box-sizing: border-box;
    padding: 12px;
`

export const Licznik = styled.div`
    text-align: center;
    font-weight: bold;
    
`